export const RELEASE = "1.0-SNAPSHOT";
